import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewEncapsulation
} from '@angular/core';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';

import { AnalyticsCoreURLService } from '../../../analytics-core/services/analytics-core.url.service';
import { CreativePerformance } from '../creative-detail-v2/creative-detail.interface';
import { StorageSessionService } from '../../../../core/storage/services/storage.session.service';
import { KEYS } from '../../../../core/service/constants/service.constants';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'app-creative-ad-preview',
	styleUrls: ['./creative-ad-preview.component.css'],
	templateUrl: './creative-ad-preview.component.html'
})
export class CreativeAdPreviewComponent implements OnInit, OnChanges, OnDestroy {
	@Input() creative: CreativePerformance;
	@Input() producttype: string;
	// tslint:disable-next-line: prefer-output-readonly
	@Output() modalClose = new EventEmitter<any>();
	public creativePreviewUrlObject: any = {};
	public iframeUrl: SafeHtml;

	constructor(
		private sanitizer: DomSanitizer,
		private analyticsCoreUrlService: AnalyticsCoreURLService,
		private storageSessionService: StorageSessionService
	) {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['creative'] && changes['creative'].currentValue) {
			this.buildPreviewURLObject();
			if (this.creative.iframeUrl !== null) {
				this.getAddIframeToDocument(this.creative.iframeUrl);
			}
		}
	}

	closeModal(): void {
		this.modalClose.emit();
	}

	buildPreviewURLObject(): void {
		if (this.creative && this.creative.isIAB && this.creative.adSizes) {
			if (this.creative.adSizes['300x600']) {
				this.creativePreviewUrlObject['300x600'] = this.getPreviewURL(300, 600);
			}
			if (this.creative.adSizes['160x600']) {
				this.creativePreviewUrlObject['160x600'] = this.getPreviewURL(160, 600);
			}
			if (this.creative.adSizes['300x250']) {
				this.creativePreviewUrlObject['300x250'] = this.getPreviewURL(300, 250);
			}
			if (this.creative.adSizes['336x280']) {
				this.creativePreviewUrlObject['336x280'] = this.getPreviewURL(336, 280);
			}
			if (this.creative.adSizes['300x50']) {
				this.creativePreviewUrlObject['300x50'] = this.getPreviewURL(300, 50);
			}
			if (this.creative.adSizes['320x50']) {
				this.creativePreviewUrlObject['320x50'] = this.getPreviewURL(320, 50);
			}
			if (this.creative.adSizes['728x90']) {
				this.creativePreviewUrlObject['728x90'] = this.getPreviewURL(728, 90);
			}
			if (this.creative.adSizes['468x60']) {
				this.creativePreviewUrlObject['468x60'] = this.getPreviewURL(468, 60);
			}
			if (this.creative.adSizes['1920x1080']) {
				this.creativePreviewUrlObject['1920x1080'] = this.getPreviewURL(1920, 1080);
			}
			if (this.creative.adSizes['1400x400']) {
				this.creativePreviewUrlObject['1400x400'] = this.getPreviewURL(1400, 400);
			}
			if (this.creative.adSizes['1080x1920']) {
				this.creativePreviewUrlObject['1080x1920'] = this.getPreviewURL(1080, 1920);
			}
			if (this.creative.adSizes['840x400']) {
				this.creativePreviewUrlObject['840x400'] = this.getPreviewURL(840, 400);
			}
			if (this.creative.adSizes['400x1400']) {
				this.creativePreviewUrlObject['400x1400'] = this.getPreviewURL(400, 1400);
			}
			if (this.creative.adSizes['400x840']) {
				this.creativePreviewUrlObject['400x840'] = this.getPreviewURL(400, 840);
			}
			if (this.creative.adSizes['1024x768']) {
				this.creativePreviewUrlObject['1024x768'] = this.getPreviewURL(1024, 768);
			}
			if (this.creative.adSizes['3840x2160']) {
				this.creativePreviewUrlObject['3840x2160'] = this.getPreviewURL(3840, 2160);
			}
			if (this.creative.adSizes['1080x1620']) {
				this.creativePreviewUrlObject['1080x1620'] = this.getPreviewURL(1080, 1620);
			}
			if (this.creative.adSizes['970x250']) {
				this.creativePreviewUrlObject['970x250'] = this.getPreviewURL(970, 250);
			} // added for 970x250 size
			if (this.creative.adSizes['1x1']) {
				this.creativePreviewUrlObject['1x1'] = this.getPreviewURL(1, 1);
			}
			if (this.creative.adSizes['1920x175']) {
				this.creativePreviewUrlObject['1920x175'] = this.getPreviewURL(1920, 175);
			}
			if (this.creative.adSizes['728x150']) {
				this.creativePreviewUrlObject['728x150'] = this.getPreviewURL(728, 150);
			}
			if (this.creative.adSizes['320x150']) {
				this.creativePreviewUrlObject['320x150'] = this.getPreviewURL(320, 150);
			}
		}
	}

	getPreviewURL(width: any, height: any): SafeUrl {
		const encryptedToken = this.storageSessionService.getToken(KEYS.STORAGE_TOKEN_ID)['f_a_token'];
		const url = `${this.analyticsCoreUrlService.serviceURL}/crtv/get_ad/${this.creative.versionId}/${width}x${height}/0/0/1?enc_tkn=${encryptedToken}`;
		const safeURL: SafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
		return safeURL;
	}

	ngOnDestroy(): void {
		this.creative = null;
		this.iframeUrl = null;
	}

	getAddIframeToDocument(iframe: any): void {
		this.iframeUrl = this.sanitizer.bypassSecurityTrustHtml(iframe);
	}
}
